/* eslint-disable react/destructuring-assignment */
import React from "react";
import { string } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedDate from "pages/_components/FormattedDate";
import Avatar from "pages/_components/Avatar";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";

const AnulateDebinSummaryBody = (props) => {
    const {
        debitAccount = props.debitAccount,
        buyerName = props.buyerName,
        buyerCuit = props.buyerCuit,
        amount = props.amount,
        solicitDate = props.solicitDate,
        dueDate = props.dueDate,
        debinId = props.debinId,
        buyerCbu = props.buyerCbu,
        alias = props.alias,
        bank = props.bank,
        concept = props.concept,
        description = props.description,
        reference = props.reference,
        curency = props.curency,
        creditAccount = props.creditAccount,
        voucher = props.voucher,
    } = props;
    return (
        <>
            <GridTable className="form-summary">
                <GridTable.Container>
                    <GridTable.Data columnStart={1}>
                        <GridTable.Container columns={2} columnsTemplate="1fr auto" rows={2} className="mb-4">
                            <GridTable.Data columnStart={2} rowStart={1}>
                                <CustomText textType="I18N" text="debin.emitter" />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={1}
                                rowStart={2}
                                columnWidth={1}
                                rowWidth={2}
                                flexDirection="column">
                                <Avatar user={{ userFullName: buyerName, defaultAvatarId: 0 }} />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={2}
                                rowStart={2}
                                columnWidth={1}
                                rowWidth={1}
                                flexDirection="column">
                                <CustomText className="data-label" text={`${buyerName} `} />
                                <CustomText className="TEXT" text={buyerCuit} />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable.Data>
                    <GridTable.Data columnStart={2}>
                        <CustomData
                            titleText="debin.details.heading.totalAmount"
                            titleTextType="I18N"
                            valueText={<FormattedAmount currency={curency} quantity={amount} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={3}>
                        <CustomData titleText="debin.dateExpitation" titleTextType="I18N" valueText={debitAccount} />
                    </GridTable.Data>
                </GridTable.Container>

                <GridTable.Container>
                    <GridTable.Data columnStart={1} columnWidth="3">
                        <div className="horizontal-divider" />
                    </GridTable.Data>
                    <GridTable.Data columnStart={1}>
                        <CustomData
                            titleText="debin.solicit.date"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={solicitDate} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={2}>
                        <CustomData
                            titleText="debin.expirery.date"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={dueDate} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={3}>
                        <CustomData titleText="debin.id" titleTextType="I18N" valueText={debinId} />
                    </GridTable.Data>
                </GridTable.Container>

                <GridTable.Container columns={3} rows={2}>
                    <GridTable.Data columnStart={1} columnWidth="3">
                        <div className="horizontal-divider" />
                    </GridTable.Data>
                    <GridTable.Data columnStart={1}>
                        <CustomData titleText="debin.cbu" titleTextType="I18N" valueText={buyerCbu} />
                    </GridTable.Data>
                    <GridTable.Data columnStart={2}>
                        <CustomData titleText="debin.alias" titleTextType="I18N" valueText={alias} />
                    </GridTable.Data>
                    <GridTable.Data columnStart={3}>
                        <CustomData titleText="debin.bank" titleTextType="I18N" valueText={bank} />
                    </GridTable.Data>
                    <GridTable.Data columnStart={1}>
                        <CustomData titleText="debin.concept.label" titleTextType="I18N" valueText={concept} />
                    </GridTable.Data>
                    <GridTable.Data columnStart={2}>
                        <CustomData titleText="debin.description.label" titleTextType="I18N" valueText={description} />
                    </GridTable.Data>
                    <GridTable.Data columnStart={3}>
                        <CustomData titleText="debin.reference" titleTextType="I18N" valueText={reference} />
                    </GridTable.Data>
                </GridTable.Container>

                <GridTable.Container columns={2} rows={1}>
                    <GridTable.Data columnStart={1} columnWidth="3">
                        <div className="horizontal-divider" />
                    </GridTable.Data>
                    <GridTable.Data columnStart={1}>
                        <CustomData titleText="debin.credit.account" titleTextType="I18N" valueText={creditAccount} />
                    </GridTable.Data>
                    <GridTable.Data columnStart={2}>
                        <CustomData titleText="debin.voucher" titleTextType="I18N" valueText={voucher} />
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>
        </>
    );
};

AnulateDebinSummaryBody.propTypes = {
    debitAccount: string,
    buyerName: string,
    buyerCuit: string,
    amount: string,
    solicitDate: string,
    dueDate: string,
    debinId: string,
    buyerCbu: string,
    alias: string,
    bank: string,
    concept: string,
    description: string,
    reference: string,
    curency: string,
    creditAccount: string,
    voucher: string,
};

AnulateDebinSummaryBody.defaultProps = {
    debitAccount: "",
    buyerName: "",
    buyerCuit: "",
    amount: "",
    solicitDate: "",
    dueDate: "",
    debinId: "",
    buyerCbu: "",
    alias: "",
    bank: "",
    concept: "",
    description: "",
    reference: "",
    curency: "",
    creditAccount: "",
    voucher: "",
};

export default AnulateDebinSummaryBody;
